import requestMaker from 'lib';

export const catalogItemDetails = data => {
  const baseQuery = `/proxy/prv/cs/cid`;
  const { slug = '' } = data;
  const params = { filter: encodeURIComponent(JSON.stringify({ slug, includeRating: true })) };
  return requestMaker(baseQuery, { params });
};
